import { VModalContext } from './context';
import type { VModalContextValue } from './type';

export const useVModal = () => VModalContext.hook() as VModalContextValue;
